import { render, staticRenderFns } from "./HorseCharge.vue?vue&type=template&id=6c0b674f&"
import script from "./HorseCharge.vue?vue&type=script&lang=js&"
export * from "./HorseCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports